module.exports = __webpack_public_path__ + "media/Video 143.092e6ac4.mp4";